import { TableHeaderItem } from "@/views/components/YtoTable/TableHeaderItem";

const defaultWidth = 300;

const tableHeader: TableHeaderItem[] = [
  { prop: 'index', label: '序号', width: null },
  { prop: 'strCarCode', label: '车签号', width: null },
  { prop: 'strBackSigntureCode', label: '后门铅封号', width: null },
  { prop: 'strMidSigntureCode', label: '中门铅封号', width: null },
  { prop: 'strSigntureStatus', label: '铅封状态', width: null },
  { prop: 'strReasonForSigntureStatus', label: '铅封状态变化原因', width: null },
  { prop: 'strResolveTime', label: '到车时间', width: null },
  { prop: 'state', label: '状态', width: null },
  { prop: 'strTip', label: '提示/警告信息', width: null },
];
export default { tableHeader }
